import { connect } from 'react-redux';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getBookedEntertainments } from '../redux/actions/bookedEntertainments';
import { saveEntertainment, deleteEntertainment } from '../redux/actions/changeAddon';
import { setNumberOfGuestsForSwimming } from '../redux/actions/swimming';
import { getBackstopDateFromApi } from '../redux/actions/backstopDate';
import {
  shouldFetch,
  filterBookedEntertainments,
  getShouldSkipSwimmingOrEntertainment,
  shouldFetchAvailableItems,
  getMaxAllowedPoolSlots,
  isAllowedToBookMorePoolSlotsOnBreak,
  getBreakLength,
  getMaxAllowedSlots,
  isAfterDailyOpeningTime,
  isBeforeBreak,
  getBackstopDate,
  shouldFetchBackstopDate,
} from '../utils';
import SwimmingDetail from '../components/swimmingDetail/SwimmingDetail';

const mapStateToProps = ({
  availableEntertainments, bookingSearch, bookedEntertainments, bookedEvents, config, swimming, backstopDate,
}, { splashId }) => ({
  splashEntertainments: availableEntertainments.splashEntertainments,
  title: 'Setup your experience',
  subTitle: 'Swimming',
  optionTitle: 'Select performance time...',
  separatorLabel: 'CLOSED FOR POOL CHANGEOVER',
  resId: bookingSearch.resId,
  siteCode: bookingSearch.siteCode,
  splashId,
  shouldFetchAvailableEntertainments: shouldFetchAvailableItems(availableEntertainments, bookingSearch, config, bookedEntertainments),
  shouldSkip: getShouldSkipSwimmingOrEntertainment(availableEntertainments.wasCalled, availableEntertainments.splashEntertainments),
  bookedEntertainmentsWithoutPastEvents: filterBookedEntertainments(availableEntertainments.splashEntertainments, bookedEntertainments.entertainments),
  shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
  numOfUnits: bookingSearch.numOfUnits,
  numOfGuests: bookingSearch.numOfGuests,
  maxAllowedPoolSlots: getMaxAllowedPoolSlots(
    bookingSearch.arrivalDate,
    bookingSearch.departureDate,
    config,
    bookedEvents.eventsWithPastEvents,
  ),
  bookedEvents: bookedEvents.events,
  bookedEventsWithPastEvents: bookedEvents.eventsWithPastEvents,
  arrivalDate: bookingSearch.arrivalDate,
  maxAllowedPoolSlotsOnSameDay: parseInt(config.REACT_APP_MAX_SWIMMING_ON_SAME_DAY, 10) || 1,
  poolRestrictionTime: config.REACT_APP_LIFT_POOL_RESTRICTION_TIME,
  maxSwimmingOnSameDay: parseInt(config.REACT_APP_MAX_SWIMMING_ON_SAME_DAY, 10) || 1,
  overlapCheckPoolItems: config.REACT_APP_OVERLAP_CHECK_POOL === 'true',
  overlapAllowedMinutes: parseInt(config.REACT_APP_OVERLAP_ALLOWED_MINUTES, 10) || 0,
  preventOverlapMandatory: config.REACT_APP_PREVENT_OVERLAP_MANDATORY === 'true',
  numberOfGuestsForSwimming: swimming.numOfGuests,
  dailySwimmingOpeningTime: config.REACT_APP_DAILY_SWIMMING_OPENING_TIME,
  dailySwimmingMax: parseInt(config.REACT_APP_DAILY_SWIMMING_MAXIMUM, 10) || 2,
  refreshTimeInterval: parseInt(config.REACT_APP_REFRESH_TIME_INTERVAL, 10) || 15,
  lastConfigCheckDateTime: config.lastConfigCheckDateTime,
  isBeforeBreak: isBeforeBreak(bookingSearch.arrivalDate, config.REACT_APP_LIFT_POOL_RESTRICTION_TIME),
  isAllowedToBookMorePoolSlotsOnBreak: isAllowedToBookMorePoolSlotsOnBreak(
    config,
    getBreakLength(bookingSearch.arrivalDate, bookingSearch.departureDate),
    bookedEvents.eventsWithPastEvents,
    bookingSearch.seasonSuffix,
  ),
  numOfPreBreakMaxAllowedPoolSlots: getMaxAllowedSlots(
    bookingSearch.arrivalDate,
    bookingSearch.departureDate,
    parseInt(config.REACT_APP_MAX_PRE_ARRIVAL_POOL_SLOTS_LESS_THAN_7_NIGHTS, 10) || 1,
    parseInt(config.REACT_APP_MAX_PRE_ARRIVAL_POOL_SLOTS_MORE_THAN_OR_EQUAL_7_NIGHTS, 10) || 1,
  ),
  isAfterDailyOpeningTime: isAfterDailyOpeningTime(config),
  backstopDate: getBackstopDate({
    config,
    departureDate: bookingSearch.departureDate,
    arrivalDate: bookingSearch.arrivalDate,
    backstopDateFromApi: backstopDate.backstopDate,
    seasonSuffix: bookingSearch.seasonSuffix,
    isEarlyAccess: bookingSearch.isEarlyAccess,
  }),
  shouldFetchBackstopDate: shouldFetchBackstopDate({ config, backstopDate, bookingSearch }),
});

const mapDispatchToProps = dispatch => ({
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
  saveEntertainment: (entertainmentsToSave, type) => dispatch(saveEntertainment(entertainmentsToSave, type)),
  deleteEntertainment: (resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, needToReportToGTM) => dispatch(
    deleteEntertainment(resId, siteCode, timeSlotId, eventDate, startTime, endTime, name, needToReportToGTM),
  ),
  setNumberOfGuestsForSwimming: numOfGuests => dispatch(setNumberOfGuestsForSwimming(numOfGuests)),
  getBackstopDateFromApi: () => dispatch(getBackstopDateFromApi()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SwimmingDetail);
